import { render, staticRenderFns } from "./Component-2.vue?vue&type=template&id=531f5eed&scoped=true&"
import script from "./Component-2.vue?vue&type=script&lang=js&"
export * from "./Component-2.vue?vue&type=script&lang=js&"
import style0 from "./Component-2.vue?vue&type=style&index=0&id=531f5eed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531f5eed",
  null
  
)

export default component.exports